export default __webpack_public_path__ + "static/media/login_bg_light.d0d07c84.jpg";